import { render, staticRenderFns } from "./SubsPayment.vue?vue&type=template&id=972bf540&scoped=true"
import script from "./SubsPayment.vue?vue&type=script&lang=js"
export * from "./SubsPayment.vue?vue&type=script&lang=js"
import style0 from "./SubsPayment.vue?vue&type=style&index=0&id=972bf540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972bf540",
  null
  
)

export default component.exports